
import{ref,inject,onMounted, reactive} from 'vue'
import headline from '@/components/headline/headline.vue'
import card from '@/components/card/card.vue'
import seckillGoods from '@/components/count-down/seckill-goods.vue'
import countDown from '@/components/count-down/count-down.vue'
import { useSeckillHooks } from '@/hooks/index'

export default {
    components:{
       headline,
       card,
       seckillGoods,
       countDown,
       
    },
      setup(){
      const $store: any = inject('$store')
      const currencyUnit = $store.getSymbol();
      const tltleImgs = `<img src="${'https://image.kilimall.com/kenya/new_wap/userCenter/ic_flash_sale.png'.webpFilters()
}" alt="">`
       const { 
        flash_sale_times_arr,
        doesList,
        havebegun,onLoad,seckillList} = useSeckillHooks()       
        onLoad()  
         
      return {       
        currencyUnit,
        flash_sale_times_arr,
        doesList,
        havebegun,
        seckillList,
        tltleImgs
        }
      }
}
